// Figuran kode untuk animatic: rusa (dari Hutan Lebat) dan warga generik — flat, tanpa outline, 1 unit = 1/1000 tinggi Pak Gub.
const R = { badan: "#8B5A2B", badanBayang: "#6E4520", perut: "#C9A275", tanduk: "#D9C9A8", mata: "#1A1A22", hidung: "#2B1B12" };

function rr(ctx, x, y, w, h, r) { ctx.beginPath(); ctx.roundRect(x, y, w, h, r); ctx.fill(); }
function el(ctx, x, y, rx, ry, rot = 0) { ctx.beginPath(); ctx.ellipse(x, y, rx, ry, rot, 0, Math.PI * 2); ctx.fill(); }

/** rusa menghadap kanan (arah=1) / kiri (-1); gerak: diam | jalan | lari */
export function gambarRusa(ctx, t, o = {}) {
  const arah = o.arah ?? 1, gerak = o.gerak || "diam";
  const f = gerak === "lari" ? 12 : gerak === "jalan" ? 6 : 0, amp = gerak === "lari" ? 0.7 : gerak === "jalan" ? 0.4 : 0;
  ctx.save(); ctx.scale(arah, 1);
  if (f) ctx.translate(0, -Math.abs(Math.sin(t * f)) * (gerak === "lari" ? 22 : 6));
  ctx.fillStyle = "rgba(0,0,0,0.28)"; el(ctx, 0, 6, 150, 20);
  // kaki (4) berayun berpasangan
  for (const [x, ph] of [[-90, 0], [-50, Math.PI], [60, Math.PI], [100, 0]]) {
    ctx.save(); ctx.translate(x, -250); ctx.rotate(f ? Math.sin(t * f + ph) * amp : 0);
    ctx.fillStyle = R.badanBayang; rr(ctx, -16, 0, 32, 150, 12); rr(ctx, -14, 140, 28, 110, 10); ctx.fillStyle = R.hidung; rr(ctx, -16, 238, 32, 16, 6); ctx.restore();
  }
  // badan + perut terang + ekor
  ctx.fillStyle = R.badan; el(ctx, 0, -320, 150, 90);
  ctx.fillStyle = R.perut; el(ctx, 10, -290, 110, 40);
  ctx.fillStyle = R.badan; el(ctx, -150, -340, 28, 18, -0.6);
  // leher + kepala (mengangguk pelan)
  ctx.save(); ctx.translate(120, -360); ctx.rotate(Math.sin(t * 1.4) * 0.06 - 0.3);
  ctx.fillStyle = R.badan; rr(ctx, -40, -150, 80, 170, 34);
  ctx.translate(0, -150);
  el(ctx, 20, 0, 70, 46); el(ctx, 80, 10, 36, 26);                       // kepala + moncong
  ctx.fillStyle = R.hidung; el(ctx, 110, 8, 10, 8);
  ctx.fillStyle = R.mata; el(ctx, 36, -12, 7, 8); ctx.fillStyle = "#fff"; el(ctx, 38, -15, 2.5, 2.5);
  ctx.fillStyle = R.badan; el(ctx, -10, -40, 16, 30, -0.4);               // telinga
  ctx.strokeStyle = R.tanduk; ctx.lineWidth = 9; ctx.lineCap = "round";   // tanduk bercabang
  for (const [dx, dy] of [[0, -110], [-40, -80], [40, -90]]) { ctx.beginPath(); ctx.moveTo(10, -40); ctx.quadraticCurveTo(10 + dx * 0.5, -40 + dy * 0.6, 10 + dx, -40 + dy); ctx.stroke(); }
  ctx.restore();
  ctx.restore();
}

const PALET_WARGA = [["#E2473B", "#1E2B5E"], ["#2A9D8F", "#3E3E52"], ["#F5B041", "#1E2B5E"], ["#7B5CD6", "#2B2B3A"], ["#3E60B3", "#6B4A2B"]];
/** warga generik kecil (tanpa wajah detail), menghadap penonton; gerak: diam | jalan | lambai */
export function gambarWarga(ctx, t, o = {}) {
  const [baju, celana] = PALET_WARGA[(o.varian ?? 0) % PALET_WARGA.length], kulit = o.kulit || "#D9A072", gerak = o.gerak || "diam";
  const f = gerak === "jalan" ? 6 : 0;
  ctx.save();
  if (f) ctx.translate(0, -Math.abs(Math.sin(t * f)) * 8);
  ctx.fillStyle = "rgba(0,0,0,0.28)"; el(ctx, 0, 6, 110, 16);
  for (const s of [-1, 1]) { ctx.save(); ctx.translate(s * 36, -400); ctx.rotate(f ? Math.sin(t * f + (s > 0 ? Math.PI : 0)) * 0.4 : 0); ctx.fillStyle = celana; rr(ctx, -34, 0, 68, 380, 22); ctx.fillStyle = "#fff"; rr(ctx, -42, 360, 84, 40, 14); ctx.restore(); }
  ctx.fillStyle = baju; rr(ctx, -95, -720, 190, 330, 40);
  for (const s of [-1, 1]) { ctx.save(); ctx.translate(s * 100, -690); ctx.rotate(gerak === "lambai" && s > 0 ? -2.6 + Math.sin(t * 6) * 0.2 : (f ? -Math.sin(t * f + (s > 0 ? Math.PI : 0)) * 0.5 : 0.15 * s)); ctx.fillStyle = baju; rr(ctx, -24, 0, 48, 230, 24); ctx.fillStyle = kulit; el(ctx, 0, 240, 26, 28); ctx.restore(); }
  ctx.fillStyle = kulit; rr(ctx, -30, -770, 60, 70, 20); el(ctx, 0, -850, 92, 100);
  ctx.fillStyle = o.rambut || "#1A1A22"; ctx.beginPath(); ctx.ellipse(0, -890, 94, 70, 0, Math.PI, 0); ctx.fill();
  ctx.fillStyle = "#1A1A22"; el(ctx, -32, -850, 7, 8); el(ctx, 32, -850, 7, 8);
  ctx.strokeStyle = "#7D3B3B"; ctx.lineWidth = 6; ctx.lineCap = "round"; ctx.beginPath(); ctx.moveTo(-20, -806); ctx.quadraticCurveTo(0, -790, 20, -806); ctx.stroke();
  ctx.restore();
}
